export default "__VITE_ASSET__78c076f3__"